import AppProviders from "./app/AppProviders";
import AppLayout from "./app/AppLayout";
import AppRouter from "./app/AppRouter";
import "./App.css";

function App() {
  return (
    <AppProviders>
      <AppLayout>
        <AppRouter />
      </AppLayout>
    </AppProviders>
  );
}

export default App;